import React, {useEffect, useState} from "react";
import {COLOR_GENERIC, COLOR_OEM, NOT_SPECIFIED, PLEASE_SELECT} from "../../../utils/constants";
import Dropdown from "../../common/Dropdown";
import {isOemColor} from "../../../utils/utils";
import isEmpty from "lodash.isempty";

const SeatTrimDropdown = (props) => {

    const {designatedDescription, designatedDescriptionResponse} = props;

    const [options, setOptions] = useState([]);
    const [showGenericOptions, setShowGenericOptions] = useState(null);
    const [showOemOptions, setShowOemOptions] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [seatTrim, setSeatTrim] = useState('');

    useEffect(() => {
        const interiorColors = designatedDescription?.colors?.interior;
        const hasDesignatedIntColor = interiorColors?.find(color => !!color.isDesignated)
        
        const currentInteriorColor = hasDesignatedIntColor ? designatedDescription.colors.interior[0] : null;

        const getInteriorColorCategory = (interiorColor) => {
            if (!interiorColor) {
                return null;
            }
            return isOemColor(interiorColor) ? COLOR_OEM : COLOR_GENERIC;
        }

        const interiorColorCategory = getInteriorColorCategory(currentInteriorColor);

        if (isEmpty(currentInteriorColor) || interiorColorCategory === null) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const hasMaterialType = () => {
            const materialType = designatedDescription?.colors?.interior?.[0]?.materialType;
            if (!materialType) {
                return false;
            }
            if (!Array.isArray(materialType)) {
                return false;
            }
            if (materialType.length === 0) {
                return false;
            }
            if (materialType.length === 1 && materialType[0] === NOT_SPECIFIED) {
                return false;
            }
            return true;
        }

        if (currentInteriorColor && hasMaterialType()) {
            setSeatTrim(designatedDescription.colors.interior[0].materialType[0])
        } else {
            setSeatTrim('')
        }

        const getOriginalVehicle = () =>  {
            const catalogVehicles = designatedDescriptionResponse?.catalogVehicles || [];
            return catalogVehicles.find(vehicle => vehicle.catalogId === designatedDescription.catalogId);
        }

        const getOriginalColor = (originalVehicle, interiorColor) => {
            let originalColor;
            let originalColors = originalVehicle?.colors?.interior || [];
            if (interiorColor && interiorColor.oemOptionCode && originalColors.length) {
                originalColor = originalColors.find(color => color.oemOptionCode === interiorColor.oemOptionCode)
            } else if (interiorColor && interiorColor.oemName && originalColors.length) {
                originalColor = originalColors.find(color => color.oemName === interiorColor.oemName)
            }
            return originalColor;
        }

        const originallyMissingMaterialType = (interiorColor, interiorColorCategory) => {
            if (interiorColor && interiorColorCategory === COLOR_OEM) {
                const originalColor = getOriginalColor(getOriginalVehicle(), interiorColor);
                return !originalColor?.materialType?.length;
            }
            return false;
        }

        const originalMaterialNotSpecified = (interiorColor, interiorColorCategory) => {
            if (interiorColor && interiorColorCategory === COLOR_OEM) {
                const originalColor = getOriginalColor(getOriginalVehicle(), interiorColor);
                return originalColor?.materialType?.includes(NOT_SPECIFIED);
            }
            return false;
        }

        // For colors with "Not Specified" material type, also check if the current color itself has "Not Specified"
        const currentMaterialNotSpecified = (interiorColor) => {
            return interiorColor?.materialType?.includes(NOT_SPECIFIED);
        }

        const originallyMissingMaterial = originallyMissingMaterialType(currentInteriorColor, interiorColorCategory);
        const materialNotSpecified = originalMaterialNotSpecified(currentInteriorColor, interiorColorCategory);
        const currentMaterialIsNotSpecified = currentMaterialNotSpecified(currentInteriorColor);

        if (interiorColorCategory === COLOR_OEM) {
            if (!originallyMissingMaterial && !materialNotSpecified && !currentMaterialIsNotSpecified) {
                setShowGenericOptions(false)
                setShowOemOptions(true)
                setOptions([currentInteriorColor])
            } else {
                setShowGenericOptions(true)
                setShowOemOptions(false)
                setOptions(props.genericInteriorTypes)
            }
        } else if (interiorColorCategory === COLOR_GENERIC) {
            setShowGenericOptions(true)
            setShowOemOptions(false)
            setOptions(props.genericInteriorTypes)
        }

    }, [props, designatedDescription?.colors?.interior, designatedDescription?.catalogId, designatedDescriptionResponse?.catalogVehicles]);

    const seatTrimIsSelected = () => {
        let installedColor;
        if (designatedDescription?.colors && designatedDescription.colors?.interior) {
            installedColor = designatedDescription.colors.interior.find(color => !!color.isDesignated);
        }
        return !!(installedColor 
            && installedColor.materialType 
            && installedColor.materialType.length
            && !installedColor.materialType.includes(NOT_SPECIFIED))
    }

    const oemOptionsToRender = (options.length && showOemOptions) ? options.map(
        option => {
            // Filter out "Not Specified" from material types for display
            const filteredMaterialTypes = option.materialType?.filter(type => type !== NOT_SPECIFIED) || [];
            if (filteredMaterialTypes.length === 0) return null;
            
            return (<option
                value={filteredMaterialTypes[0]}
                key={option.oemOptionCode}
            >{filteredMaterialTypes.join('/')}</option>)
        }
    ).filter(Boolean) : [];

    const genericOptionsToRender = (options.length && showGenericOptions) ? options.map(
        option => {
            return (<option
                value={option.name}
                key={option.name}
            >{option.name}</option>)
        }
    ) : [];

    return (
        <Dropdown
            value={seatTrim}
            key={seatTrim}
            id='configure-seat-trim'
            onChange={props.onChange}
            disabled={disabled}
        >
            {!seatTrimIsSelected() &&
                <option value='' disabled>{PLEASE_SELECT}</option>}
            {oemOptionsToRender}
            {genericOptionsToRender}
        </Dropdown>
    )
};

export default SeatTrimDropdown;